// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__vO1B1","boxTitle":"Qualiphy_boxTitle__2nw2s","box":"Qualiphy_box__3_Fpj","toggleWrap":"Qualiphy_toggleWrap__2PmhF"};